// extracted by mini-css-extract-plugin
export var animationContainer = "_gs-0";
export var asteriskIcon = "_gs-8";
export var conversationLeftSection = "_gs-4";
export var conversationListItem = "_gs-3";
export var conversationMiddleSection = "_gs-5";
export var conversationRightSection = "_gs-6";
export var detailsContent = "_gs-1";
export var listContainer = "_gs-7";
export var modalContent = "_gs-2";